import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {PatientService} from '../../../services/patient/patient.service';
import {PatientModel} from '../../../models/patient/patient.model';
import {iResponse} from '../../../models/response/response.model';
import {
    PatientProfileAdministrationComponent
} from '../patient-profile-administration/patient-profile-administration.component';

@Component({
    selector: 'app-profile',
    imports: [
        PatientProfileAdministrationComponent,
    ],
    templateUrl: './profile.component.html',
    styleUrl: './profile.component.sass',
    standalone: true
})
export class ProfileComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    profile: PatientModel | null = null;

    constructor(
        private patientService: PatientService,
    ) {
    }

    ngOnInit(): void {
        this.getProfile();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private getProfile(): void {
        this.patientService.getMe()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponse<PatientModel>) => {
                    this.profile = response.data;
                },
                error: (error) => {
                }
            })
    }
}
